<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
    <path fill="#000" fill-rule="evenodd" d="M6.454 4.277a.793.793 0 0 0-1.205 0c-.332.37-.332.969 0 1.338l3.898 4.331-3.898 4.331c-.332.37-.332.969 0 1.338.333.37.872.37 1.205 0l3.897-4.331 3.898 4.331c.333.37.872.37 1.204 0a1.02 1.02 0 0 0 0-1.338l-3.897-4.33 3.898-4.332c.332-.37.332-.968 0-1.338a.793.793 0 0 0-1.205 0l-3.898 4.331-3.897-4.33Z" clip-rule="evenodd"></path>
  </svg>
</template>
